import { SxProps, Theme } from "@mui/material/styles";

export const homeContainer: SxProps<Theme> = {
    width: {
        xs: "100%",
        md: "50%",
    },
    mx: "auto",
};

export const summaryBox: SxProps<Theme> = (theme: Theme) => ({
    p: 3,
    border: 1,
    borderColor: "white",
    borderRadius: "8px",
    backgroundColor: theme.palette.primary.dark,
    color: "white",
    textAlign: "center",
    minHeight: "200px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
});

export const answersGrid: SxProps<Theme> = {
    mt: 2,
    justifyContent: "space-around",
    px: 0.5,
};

export const card: SxProps<Theme> = {
    textDecoration: "none",
    padding: 0,
    margin: 0,
}

export const cardContent: SxProps<Theme> = {
    display: "flex",
    justifyContent: "center",
    padding: 1,
    "&:last-child": {
        paddingBottom: 0
    },
}

export const grid: SxProps<Theme> = (theme: Theme) => ({
    minWidth: 160,
})

export const typography: SxProps<Theme> = (theme: Theme) => ({
    color: theme.palette.common.white,
})

export const cardMedia: SxProps<Theme> = {
    height: 140,
    width: 120,
    margin: "0 auto",
    borderRadius: 3,
}